import React from 'react'
import { formatAnnouncementDates } from '@/announcement/announcement'
import useDateLocale from '@/common/hooks/useDateLocale'
import { Badge, Button, HStack, Td, Text, Tr } from '@chakra-ui/react'
import { AnnouncementFragment } from '@gql'
import { useTranslation } from 'react-i18next'

const typeColors: Record<string, string> = {
  upcoming: 'blue',
  maintenance: 'orange',
}

interface Props {
  announcement: AnnouncementFragment
  current: boolean
  onEdit(): void
  onDelete(): void
}

export default function AdminAnnouncementRow({
  announcement,
  current,
  onEdit,
  onDelete,
}: Props) {
  const { t } = useTranslation()
  const dateLocale = useDateLocale()

  return (
    <Tr color={current ? undefined : 'gray.500'}>
      <Td>
        <Badge colorScheme={current ? 'green' : 'gray'}>
          {current
            ? t('SuperAdmin.announcements.current')
            : t('SuperAdmin.announcements.past')}
        </Badge>
      </Td>
      <Td>
        <Badge colorScheme={typeColors[announcement.type] ?? 'gray'}>
          {t(`AnnouncementBanner.types.${announcement.type as 'upcoming'}`)}
        </Badge>
      </Td>
      <Td maxW="380px" whiteSpace="normal">
        <Text noOfLines={2}>{announcement.message}</Text>
      </Td>
      <Td>
        {formatAnnouncementDates(
          announcement.startsAt,
          announcement.endsAt,
          dateLocale
        )}
      </Td>
      <Td>
        <HStack justify="end" spacing={1}>
          {current && (
            <Button size="xs" onClick={onEdit}>
              {t('SuperAdmin.announcements.edit')}
            </Button>
          )}
          <Button
            size="xs"
            variant="ghost"
            colorScheme="red"
            onClick={onDelete}
          >
            {t('common.delete')}
          </Button>
        </HStack>
      </Td>
    </Tr>
  )
}
